module.exports = __webpack_public_path__ + "img/013-wind-1.10d50c43.svg";